import { startOfMonth } from '@internationalized/date';
import { Controller, useFormContext } from 'react-hook-form';

import {
  benefitsExpirationValidationMessage,
  benefitsWillExpireOptions,
  IncomeSourceFormT,
  MAX_BENEFITS_EXPIRATION_YEARS,
  todayCentral,
  validateBenefitsExpiration,
} from '@consumer-frontend/nc-utils';

import { ExpirationField } from './ExpirationField';
import { NcIncomeSourceAmountField } from './NcIncomeSourceAmountField';
import { NcRadioGroup } from '../NcRadioGroup';

export type NcIncomeSourceBenefitsFormPropsT = {
  showAmountField?: boolean;
};

export type NcIncomeSourceBenefitsFormT = React.FC<NcIncomeSourceBenefitsFormPropsT>;

export const NcIncomeSourceBenefitsForm: NcIncomeSourceBenefitsFormT = ({
  showAmountField = false,
}) => {
  const {
    control,
    formState: { errors },
    watch,
  } = useFormContext<IncomeSourceFormT>();

  const minDate = startOfMonth(todayCentral());
  const maxDate = minDate.add({ years: MAX_BENEFITS_EXPIRATION_YEARS });
  const selectedBenefitsWillExpire = watch('benefits.willExpire');
  const showBenefitsExpirationField = selectedBenefitsWillExpire === 'yes';

  return (
    <>
      <Controller
        control={control}
        name="benefits.willExpire"
        rules={{
          required: 'Select an answer to continue.',
        }}
        render={({ field }) => (
          <NcRadioGroup
            controlId="benefits-will-expire"
            errorMessage={errors.benefits?.willExpire?.message}
            groupError={Boolean(errors.benefits?.willExpire)}
            label="Will your benefits expire?"
            onChange={field.onChange}
            options={benefitsWillExpireOptions}
            ref={field.ref}
            value={field.value}
          />
        )}
      />

      {showBenefitsExpirationField && (
        <Controller
          control={control}
          shouldUnregister
          name="benefits.expiration"
          rules={{
            required: benefitsExpirationValidationMessage,
            validate: validateBenefitsExpiration,
          }}
          render={({ field }) => (
            <ExpirationField
              errorMessage={errors.benefits?.expiration?.message}
              max={maxDate}
              min={minDate}
              onChange={(date) => field.onChange(
                date ? `${date.year}-${String(date.month).padStart(2, '0')}` : undefined,
              )}
              value={field.value}
            />
          )}
        />
      )}

      {showAmountField && (
        <NcIncomeSourceAmountField label="Pay Per Benefits Check (After Taxes)" />
      )}
    </>
  );
};
